module.exports = __webpack_public_path__ + "img/LOGO-white.63b004c2.svg";